import axios from "axios";
import { toast } from "react-toastify";
import Constants from "./constant";

export const baseURL = process.env.REACT_APP_BASE_URL;
export const LoginURL = process.env.REACT_APP_MVC_LOGIN;
export const MvcAPPURL = process.env.REACT_APP_MVC_URL;

export const fetch = async (
  url,
  showToast = false,
  forSave = false,
  forDelete = false,
  forEdit = false
) => {
  let res = null;
  try {
    const response = await axios.get(baseURL + url);
    res = response.data;
    if (showToast && forSave) {
      if (res) {
        toast.success(Constants.successFullySaved);
      } else {
        toast.error(Constants.failToSave);
      }
    }
    if (showToast && forEdit) {
      if (res) {
        toast.success(Constants.successfullyUpdated);
      } else {
        toast.error(Constants.failToEdit);
      }
    }
    if (showToast && forDelete) {
      if (res) {
        toast.success(Constants.successfullyDeleted);
      } else {
        toast.error(Constants.failToDelete);
      }
    }
  } catch (error) {
    console.error(error);
    if (showToast && forSave) {
      toast.error(Constants.failToSave);
    }
    if (showToast && forDelete) {
      toast.error(Constants.failToDelete);
    }
  }
  return res;
};

export const post = async (
  url,
  data,
  showToast = true,
  forSave = true,
  forDelete = false,
  forEdit = false
) => {
  let res = null;
  try {
    const response = await axios.post(baseURL + url, data);
    res = response.data;
    if (showToast && forSave) {
      if (res) {
        toast.success(Constants.successFullySaved);
      } else {
        toast.error(Constants.failToSave);
      }
    }
    if (showToast && forEdit) {
      if (res) {
        toast.success(Constants.successfullyUpdated);
      } else {
        toast.error(Constants.failToEdit);
      }
    }
    if (showToast && forDelete) {
      if (res) {
        toast.success(Constants.successfullyDeleted);
      } else {
        toast.error(Constants.failToDelete);
      }
    }
  } catch (error) {
    console.error(error);
    if (showToast && forSave) {
      toast.error(Constants.failToSave);
    }
    if (showToast && forDelete) {
      toast.error(Constants.failToDelete);
    }
  }
  return res;
};

export const postForm = async (
  url,
  data,
  showToast = true,
  forSave = true,
  forDelete = false,
  forEdit = false
) => {
  let res;
  try {
    const response = await axios.post(baseURL + url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    res = response.data;
    if (showToast && forSave) {
      if (res) {
        toast.success(Constants.successFullySaved);
      } else {
        toast.error(Constants.failToSave);
      }
    }
    if (showToast && forEdit) {
      if (res) {
        toast.success(Constants.successfullyUpdated);
      } else {
        toast.error(Constants.failToEdit);
      }
    }
    if (showToast && forDelete) {
      if (res) {
        toast.success(Constants.successfullyDeleted);
      } else {
        toast.error(Constants.failToDelete);
      }
    }
  } catch (error) {
    console.error(error);
    if (showToast && forSave) {
      toast.error(Constants.failToSave);
    }
    if (showToast && forDelete) {
      toast.error(Constants.failToDelete);
    }
  }
  return res;
};
